// extracted by mini-css-extract-plugin
export var quantityInput = "_hj-0";